import { render, staticRenderFns } from "./SubscribeForm.vue?vue&type=template&id=4654ac0a&scoped=true"
import script from "./SubscribeForm.vue?vue&type=script&lang=ts"
export * from "./SubscribeForm.vue?vue&type=script&lang=ts"
import style0 from "./SubscribeForm.vue?vue&type=style&index=0&id=4654ac0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654ac0a",
  null
  
)

export default component.exports